import { StudentAssignmentResponse } from "shared/types/studentTypes"
import { AssignmentResponse } from "shared/types/teacherTypes"

export const isStudentAssignment = (isStudent: boolean, assignment: AssignmentResponse | StudentAssignmentResponse): assignment is StudentAssignmentResponse => {
    return isStudent
}
